import { compose, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import { reduxForm, SubmissionError } from 'redux-form'

import {
  Input,
  Button
} from '../uiLib'
import { defaultValidators, reduxErrorFormatter } from '../../lib/validation'
import {
  getImmobilizerCode
} from '../../reducers/security-code'
import SecurityCodeRequestStatus from './SecurityCodeRequestStatus'
import { notify } from '../../lib/notification'
import NotePanel from './NotePanel'


const ImmobilizerCodeForm = props => {
  const { t, loading, user } = props
  return (
    <div className="immob-form immob-form--serial">
      <span className="immob-eyebrow immob-eyebrow--muted">{t('common:pats-eyebrow-serial')}</span>
      <h1 className="immob-form-title">{t('common:pats-page-content-11')}</h1>

      { props.immobilizer.request_sent ? (
        <SecurityCodeRequestStatus
          securityCode={props.immobilizer}
          setCodeType={props.setCodeType}
          handleResetForm={props.handleResetForm}
          type="immobilizer"
          t={t}
        />
      ) : (
        <div className="immob-form-grid">
          <div className="immob-form-main">
            <form onSubmit={props.handleSubmit(props._handleSubmit)}>
              <Input
                id="vin"
                name="vin"
                size="normal"
                label={t('common:vin')}
                formComponent
                type="text"
                placeholder={t('common:enter-vin')}
                disabled={loading}
                validate={[
                  defaultValidators.required,
                  defaultValidators.vin,
                  defaultValidators.length(17)
                ]} />
              <Input
                id="serial_number"
                name="serial_number"
                size="normal"
                label={t('common:immobilizer-serial-number')}
                formComponent
                type="text"
                placeholder={t('common:enter-immobilizer-serial-number')}
                disabled={loading}
                validate={[
                  defaultValidators.required,
                  defaultValidators.length(10)
                ]} />
              <div className="immob-actions">
                <Button
                  type="button"
                  btType="default"
                  onClick={() => props.setCodeType('')}
                  disabled={loading}
                >
                  {t('common:back')}
                </Button>
                <Button
                  btType="primary"
                  disabled={loading}
                  loading={loading}
                >
                  {t('common:submit')}
                </Button>
              </div>
            </form>
          </div>

          <div className="immob-help">
            <NotePanel t={t} user={user} />
          </div>
        </div>
      ) }
    </div>
  )
}

const mapStateToProps = state => ({
  immobilizer: state.securityCode.immobilizer,
  loading: state.securityCode.loading,
  error: state.securityCode.error
})

const mapDispatchToProps = dispatch => ({
  createNotification: opts => dispatch(notify(opts)),
  getImmobilizerCode: car_data => dispatch(getImmobilizerCode(car_data))
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    _handleSubmit: ({ getImmobilizerCode, t, createNotification }) => data => {
      return getImmobilizerCode(data)
      .catch(err => {

        let reduxFormErr = {
          _error: t('server-error')
        }

        if (err.response.status === 400) {
          reduxFormErr = {
            ...reduxFormErr,
            ...reduxErrorFormatter(err.response.data)
          }
        } else {
          createNotification({
            type: 'error',
            message: t('server-error')
          })
        }
        throw new SubmissionError(reduxFormErr)
      })
    }
  }),
  reduxForm({
    destroyOnUnmount: false,
    form: 'immobilizer_code'
  })
)(ImmobilizerCodeForm)



// WEBPACK FOOTER //
// ./components/PATSCodes/ImmobilizerCodeForm.js